import React, { useState } from "react";
import { all_routes } from "../../router/all_routes";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/recruiterSidebar";
import { Link } from "react-router-dom";
import SettingsLinks from "./settingsLinks/settingsLinks";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import BackendImage from "../../../core/common/backendImage";
import CustomSelect from "../../../core/common/commonSelect";
import { Country, Gender, maritalStatus } from "../../../core/common/selectOption/json/selectOption";
import { DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { User } from "../../../core/types/types";
import axios from "axios";
import dayjs from 'dayjs';
import { updateUser } from "../../../core/redux/authSlice";
import apiInstance from "../../../utility/apiInstance";
import RecruiterSidebar from "../common/recruiterSidebar";
import { ALPHA_REGEX, stripNonAlpha, stripNonNumeric } from "../../../utility/inputValidators";

const RecruiterSettings = () => {
    const route = all_routes;
    const dispatch = useDispatch();

    const user = useSelector((state: any) => state.auth.user);

    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

    const [errorField, setErrorField] = useState('');

    const [imagePreview, setImagePreview] = useState<string | null>(
        user?.image?.url || null
    );
    const [imageUploading, setImageUploading] = useState(false);

    const [formData, setFormData] = useState<User>({
        id: user?.id || '',
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        image: user?.image?.id || user?.image || null,
        email: user?.email || '',
        username: user?.username || '',
        phone: user?.phone || '',
        cellPhone: user?.cellPhone || '',
        whatsapp: user?.whatsapp || '',
        role: user?.role || '',
    })

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const fd = new FormData();
        fd.append('file', file);
        fd.append('alt', 'Profile photo');
        try {
            setImageUploading(true);
            const res = await apiInstance.post('/api/media', fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            const media = res.data?.doc || res.data;
            setFormData(prev => ({ ...prev, image: media.id }));
            setImagePreview(media.url || null);
        } catch {
            setMsg({ error: true, loading: false, text: 'Image upload failed' });
        } finally {
            setImageUploading(false);
        }
    };

    const removeImage = () => {
        setFormData(prev => ({ ...prev, image: null }));
        setImagePreview(null);
    };

    const getModalContainer = () => {
        const modalElement = document.getElementById("add_assignment");
        return modalElement ? modalElement : document.body;
    };

    const handleInputChange = (
        e: any
    ) => {
        const { name } = e.target;
        let { value } = e.target;
        if (typeof value === 'string' && (name === 'firstName' || name === 'lastName')) {
            value = stripNonAlpha(value);
        } else if (typeof value === 'string' && (name === 'phone' || name === 'cellPhone' || name === 'whatsapp')) {
            value = stripNonNumeric(value);
        }
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }))
        if (errorField === name) setErrorField('');
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{7,15}$/;

    const validate = () => {
        let newErrors = '';
        let invalidField = '';

        if (!formData.firstName?.trim() || !ALPHA_REGEX.test(formData.firstName)) {
            newErrors = "Valid first name is required";
            invalidField = 'firstName';
        } else if (!formData.lastName?.trim() || !ALPHA_REGEX.test(formData.lastName)) {
            newErrors = "Valid last name is required";
            invalidField = 'lastName';
        } else if (!formData.email?.trim() || !emailRegex.test(formData.email)) {
            newErrors = "Valid email is required";
            invalidField = 'email';
        } else if (!formData.username?.trim()) {
            newErrors = "Username is required";
            invalidField = 'username';
        } else if (!/^[a-zA-Z0-9_.]+$/.test(formData.username.trim())) {
            newErrors = "Username may only contain letters, numbers, underscores (_) and periods (.)";
            invalidField = 'username';
        } else if (!formData.phone?.trim() || !phoneRegex.test(formData.phone)) {
            newErrors = "Valid phone number is required";
            invalidField = 'phone';
        } else if (formData.cellPhone?.trim() && !phoneRegex.test(formData.cellPhone)) {
            newErrors = "Valid cell phone number is required";
            invalidField = 'cellPhone';
        } else if (!formData.whatsapp?.trim() || !phoneRegex.test(formData.whatsapp)) {
            newErrors = "Valid whatsapp number is required";
            invalidField = 'whatsapp';
        }

        setErrorField(invalidField);

        setMsg({
            error: true,
            loading: false,
            text: newErrors
        })

        return newErrors.length === 0
    };

    const updateProfile = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validate()) return;

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/users/${formData.id}`, formData);
            dispatch(updateUser(response.data.doc))
            setMsg({
                error: false,
                loading: false,
                text: 'Profile updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <RecruiterSidebar />
                        {/* sidebar */}
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={updateProfile}>
                                        <div className="profile-upload-group">
                                            <div className="d-flex align-items-center">
                                                <span className="avatar flex-shrink-0 avatar-xxxl avatar-rounded border me-3">
                                                    <BackendImage
                                                        src={imagePreview ?? undefined}
                                                        fallback="/assets/img/user/user-02.jpg"
                                                        alt="Profile"
                                                        className="img-fluid"
                                                    />
                                                </span>
                                                <div className="profile-upload-head">
                                                    <h6>Profile Photo</h6>
                                                    <p className="fs-14 mb-0">
                                                        PNG or JPG no bigger than 800px width and height
                                                    </p>
                                                    <div className="new-employee-field">
                                                        <div className="d-flex align-items-center mt-2">
                                                            <div className="image-upload position-relative mb-0 me-2">
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={handleImageUpload}
                                                                    disabled={imageUploading}
                                                                />
                                                                <Link
                                                                    to="#"
                                                                    className="btn bg-gray-100 btn-sm rounded-pill image-uploads"
                                                                >
                                                                    {imageUploading ? 'Uploading...' : 'Upload'}
                                                                </Link>
                                                            </div>
                                                            {imagePreview && (
                                                            <div className="img-delete">
                                                                <Link
                                                                    to="#"
                                                                    className="btn btn-secondary btn-sm rounded-pill"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        removeImage();
                                                                    }}
                                                                >
                                                                    Delete
                                                                </Link>
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="edit-profile-info mb-3">
                                                <h5 className="mb-1">Personal Details</h5>
                                                <p>Edit your personal information</p>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            First Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'firstName' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="firstName"
                                                            value={formData.firstName}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'firstName' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Last Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'lastName' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="lastName"
                                                            value={formData.lastName}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'lastName' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            User Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'username' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="username"
                                                            value={formData.username}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'username' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Phone Number{" "}
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'phone' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="phone"
                                                            value={formData.phone}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'phone' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Cell Phone Number
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'cellPhone' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="cellPhone"
                                                            value={formData.cellPhone}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'cellPhone' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            WhatsApp Number <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'whatsapp' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="whatsapp"
                                                            value={formData.whatsapp}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'whatsapp' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <button
                                                        className="btn btn-secondary rounded-pill"
                                                        type="submit"
                                                    >
                                                        Update Profile
                                                    </button>
                                                    {msg.loading &&
                                                        <span className="mt-3 fs-14 fw-normal d-flex align-items-center justify-content-center">Updating profile...</span>
                                                    }
                                                    {!msg.loading && !errorField &&
                                                        <span className={`mt-3 ${msg.error ? 'text-red' : ''} fs-14 fw-normal d-flex align-items-center justify-content-center`}>{msg.text}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecruiterSettings;
